import { render } from "./NotiSettingsView.vue?vue&type=template&id=0a844a09"
import script from "./NotiSettingsView.vue?vue&type=script&lang=js"
export * from "./NotiSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__